import React, {useEffect, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import {getProducts} from "../../lib/product";
import {getCategory} from "../../lib/category";
import {getSessions} from "../../lib/session";
import TrainingHighlighted from "../../components/job-featured/TrainingHighlighted"
import FormationFilterTab from "../../components/job-featured/FormationFilterTab";
import axios from "axios";
import { Hero8, Libre, Main1, Main2, Ressources } from "../../components";
import Parser from "html-react-parser";
import CalendrierGlobalSessions from "../../components/CalendrierGlobalSessions";
import Seo from "../../components/common/Seo";
import Header from "../../components/home-7/Header";
import MobileMenu from "../../components/header/MobileMenu";
import {getHighlighted} from "../../lib/Hightlighted";
import {Link} from "react-router-dom";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CtaFormation from "../../components/formation-single-pages/CtaFormation";

function FormationsPageAPi() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const { data: products } = useQuery({
        queryKey: ["products"],
        queryFn: getProducts,
    });
    const { data: category } = useQuery({
        queryKey: ["category"],
        queryFn: getCategory,
    });

    const { data: sessions } = useQuery({
        queryKey: ["sessions"],
        queryFn: getSessions,
    });

    const { data: highlighted } = useQuery({
        queryKey: ["highlighted"],
        queryFn: getHighlighted
    });

    const [formationPageData, setFormationPageData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get( `${apiUrl}/front_pages?type=4`);
                setFormationPageData(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Erreur lors de la récupération des données :', error);
            }
        };

        fetchData();
    }, [apiUrl]);

    function CtaContact(){
        return (
            <section className="cta-section">
                <div className="auto-container">
                    <div className="row justify-content-end align-items-center">
                        <figure className="image">
                            <LazyLoadImage
                                src='../../images/background/cta-bg.jpg'
                                alt='cta'
                                effect="blur"
                            />
                        </figure>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="inner-container wow fadeIn animated">
                                <div className="title-box">
                                    <h2 className={'cta-title'}>
                                        Vous hésitez sur la formation à choisir ?
                                    </h2>
                                    <div className="text">
                                        Nos conseillers pédagogiques sont là pour vous guider. Parlons de vos enjeux !
                                        Contactez nos experts ou téléchargez notre catalogue de formation
                                    </div>
                                    <Link to={'/contact'}
                                          className={'theme-btn btn-style-six small'}>
                                          Contactez-nous !
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
            <>
                {!loading && (
                    <>
                        <Seo pageTitle={formationPageData[0]?.titre} pageDescription={formationPageData[0]?.description} pageUrl={window.location.href} />

                        <span className="header-span"></span>

                        <Header />
                        <MobileMenu />
                        {formationPageData?.map((formationPage, formationPageIndex) => (
                            <React.Fragment key={`formationPage-${formationPageIndex}`}>
                                {formationPage?.frontPageContainers?.map((container, containerIndex) => (
                                    <div key={containerIndex}>
                                        {container?.banner && (
                                            <React.Fragment key={`banner-${containerIndex}`}>
                                                {container.frontPageContents?.map((content, contentIndex) => (
                                                    <Hero8 key={`hero-${contentIndex}`} content={content} titleBreadcrumb={formationPageData[0]?.titre} />
                                                ))}
                                            </React.Fragment>
                                        )}

                                        {container?.libre && (
                                            <React.Fragment key={`libre-${containerIndex}`}>
                                                <Libre
                                                    background={container.background_color}
                                                    title={container.frontPageContents[0]?.titre}
                                                    description={container.frontPageContents[0]?.description}
                                                    index={container.frontPageContents[0]?.index}
                                                    align={'start'}
                                                    justify={'start'}
                                                    type={'formation'}
                                                />
                                            </React.Fragment>
                                        )}

                                        {container?.formationEnAvant === true && (
                                            <React.Fragment key={`formationAvant-${containerIndex}`}>
                                                <section className="news section layout-pt-20 layout-pb-20"
                                                         style={{ backgroundColor: 'rgb(247, 254, 246)' }}>
                                                    <div className="auto-container">
                                                        {highlighted?.length > 0 &&(
                                                            <div className="row wow fadeInUp animated">
                                                                <TrainingHighlighted products={highlighted}/>
                                                            </div>
                                                        )}
                                                    </div>
                                                </section>
                                            </React.Fragment>
                                        )}

                                        {container?.formation && (
                                            <React.Fragment key={`formations-${containerIndex}`}>
                                                <section className="news section layout-pt-20 layout-pb-20">
                                                    <div className="auto-container">
                                                        <div className="row wow fadeInUp animated">
                                                            <FormationFilterTab products={products} category={category}/>
                                                        </div>
                                                    </div>
                                                </section>
                                            </React.Fragment>
                                        )}
                                        {container?.demandeInformation && (
                                            <React.Fragment key={`demandeInformations-${containerIndex}`}>
                                                <CtaContact />
                                            </React.Fragment>
                                        )}


                                        {sessions?.length > 0 && container?.formationsInterEntrepriseV1 && (
                                            <React.Fragment key={`formationsInterEntrepriseV1-${containerIndex}`}>
                                                <CalendrierGlobalSessions
                                                    title={container?.titre}
                                                    description={container?.description}
                                                    index={containerIndex}
                                                />
                                            </React.Fragment>
                                        )}

                                        {container?.ressources && (
                                            <React.Fragment key={`ressource-${containerIndex}`}>
                                                <Ressources
                                                    background={container.background_color}
                                                    title={container.titre}
                                                    description={container.description}
                                                />
                                            </React.Fragment>
                                        )}
                                        {container?.main1 && (
                                            <React.Fragment key={`main1-${containerIndex}`}>
                                                <Main1
                                                    background={container.background_color}
                                                    image={container.frontPageContents[0]?.image[0]}
                                                    title={container.frontPageContents[1]?.titre}
                                                    description={container.frontPageContents[1]?.description}
                                                    url={container.frontPageContents[1]?.url}
                                                    button={container.frontPageContents[1]?.button}
                                                />
                                            </React.Fragment>
                                        )}

                                        {container?.main2 && (
                                            <React.Fragment key={`main2-${containerIndex}`}>
                                                <Main2
                                                    background={container.background_color}
                                                    image={container.frontPageContents[1]?.image[0]}
                                                    title={container.frontPageContents[0]?.titre}
                                                    description={container.frontPageContents[0]?.description}
                                                    url={container.frontPageContents[0]?.url}
                                                    button={container.frontPageContents[0]?.button}
                                                />
                                            </React.Fragment>
                                        )}
                                    </div>
                                ))}
                            </React.Fragment>
                        ))}
                    </>
                )}
            </>
    );
}

export default FormationsPageAPi;
